export class DomDetectorQuery {

  /** @type {string[]} */
  elementQuery;

  /** @type {function} */
  callback;

  /**
   * @param {string[]} elementQuery
   * @param {function} callback
   */
  constructor(elementQuery, callback) {
    this.elementQuery = elementQuery;
    this.callback = callback;
  }

}
